// Controller
export const SYSNC_BIO_ONLY = "0";
export const SYNC_NON_BIO_ONLY = "1";
export const SYNC_ALL = '2';
export const SYNC_SELECTED = '3';
